import React  from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/ru_RU';
import moment from 'moment';
import { ReactComponent as CalendarIcon } from '../../images/calendar.svg';

const Date = styled.div`
  &&& {
    .customDate {
      .ant-picker-header {
        position: relative;
        height: 38px;
        button.ant-picker-month-btn {
          position: absolute;
          left: 71px;
          color: #4b97e9;
        }

        button.ant-picker-header-next-btn {
          position: absolute;
          left: 103px;
        }

        button.ant-picker-header-prev-btn {
          position: absolute;
          left: 37px;
        }
        button.ant-picker-year-btn {
          position: absolute;
        }

        button.ant-picker-header-prev-btn {
          position: absolute;
          left: 37px;
        }

        button.ant-picker-year-btn {
          position: absolute;
          right: 65px;
          color: #4b97e9;
        }

        button.ant-picker-header-super-next-btn {
          position: absolute;
          right: 27px;
          .ant-picker-super-next-icon {
            &:after {
              display:none;
            }
          }
        }

        button.ant-picker-header-super-prev-btn {
          position: absolute;
          right: 109px;
          .ant-picker-super-prev-icon{
            &:after {
              display:none;
            }
        }
      }
    }
  }
`;

function DatePickerComponent({ value, disabled }) {
  return (
    <Date>
      <div className="customDate"></div>
      <DatePicker
        disabled={disabled ? true : false}
        locale={locale}
        defaultValue={value ? moment(value) : null}
        showToday={false}
        allowClear={false}
        format="DD MMMM hh:mm"
        getPopupContainer={() => document.querySelector('.customDate')}
        className="rounded-xs h-50 w-full ml-4"
        suffixIcon={<CalendarIcon />}
      />
    </Date>
  );
}

DatePickerComponent.propTypes = {};

export default DatePickerComponent;
